export default __webpack_public_path__ + "static/Entenda0100-32cd10b0378c23603c6b22f46d2a242e.jpg";